import client from '../client'

export const calculateShipmentRateKey = `${process.env.NEXT_PUBLIC_PURCHASE_DOMAIN}/api/Calculations/CalculateShipmentRate`

export async function calculateShipmentRate({ vehicleId, destinationZipCode }) {
  const params = new URLSearchParams({ vehicleId })

  if (destinationZipCode) params.set('destinationZipCode', destinationZipCode)

  return client(`${calculateShipmentRateKey}?${params}`)
}
